import OverlaySlideWrap from '../overlay/OverlaySlideWrap'
import SidebarCollection from '../sidebar/SidebarCollection'

interface P {
  isOpen,
  setIsOpen,
}
const CollectionOverlayFilter: React.FC<P> = ({ 
  isOpen,
  setIsOpen,
  // ...props
}: P) => {

  return (
    <OverlaySlideWrap
      className="collection-overlay-filter"
      title="Filter"
      isActive={isOpen}
      setIsActive={setIsOpen}
    >
    <SidebarCollection style={{marginTop: '-16px'}} />
    </OverlaySlideWrap>
  )
}

export default CollectionOverlayFilter